import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-43dd163d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "info__logo",
  width: "40",
  height: "40",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_3 = { class: "info__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info__desc" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Documents: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://bamboo-docs.vercel.app/",
    target: "_blank",
    rel: "noopener"
  }, " https://bamboo-docs.vercel.app ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.name), 1),
    _hoisted_4
  ]))
}